import {makeObservable, observable, action, runInAction} from 'mobx';
import { BookingListItem, BookingDetail } from '../model/professional/booking-model';

/**
 * Store pour gérer l'état des réservations
 */
class BookingStore {
  // État observable des réservations
  @observable bookings: BookingListItem[] = [];
  @observable selectedBooking: BookingDetail | null = null;
@observable isLoading: boolean = false

  constructor() {
    makeObservable(this);
  }

  setIsLoading(){
    this.isLoading = true
  }

  // Actions pour modifier l'état
  @action
  setBookings(bookings: BookingListItem[]) {
    this.bookings = bookings;
    this.setIsLoading()
  }

  updateAppointment(id: string, newStatus: 'confirmed' | 'cancelled' | 'completed') {
    runInAction(() => {
      this.bookings = this.bookings.map(appointment =>
          appointment.id === id ? { ...appointment, status: newStatus } : appointment
      );
    });
  }

  @action
  setSelectedBooking(booking: BookingDetail | null) {
    this.selectedBooking = booking;
  }
}

// Exporter une instance singleton du store
export const bookingStore = new BookingStore();
